import './BodyContent.css'; // 스타일링을 위한 CSS 파일을 임포트합니다.
import { Navigate, Route, Routes } from 'react-router-dom';
import { isBranchSite } from '../utils/site';
import BranchPlaceStat from '../pages/branch/place_stat';
import BranchAcceptStat from '../pages/branch/accept_stat';
import Dashboard from '../pages/dashboard';
import PlaceList from '../pages/place/list';
import TestingPlaceJoins from '../pages/testing_place/joins';
import TestingPlaceList from '../pages/testing_place/list';
import TestingPlaceScheduleJoins from '../pages/testing_place_schedule/joins';
import TestingPlaceSchedulePlan from '../pages/testing_place_schedule/plan';
import TestingTeacherSetup from '../pages/testing_teacher/setup';
import TestingTeacherJoins from '../pages/testing_teacher/joins';
import TestingAcceptList from '../pages/testing_accept/list';
import TestingAcceptStat from '../pages/testing_accept/stat';
import TestingPrintList from '../pages/testing_print/list';
import TestingHqDoc from '../pages/testing_hq_doc/list';
import TestingReportList from '../pages/testing_report/list';

const BodyContent = () => {
  // branch 사이트는 현황 2개 화면만 라우팅한다.
  // (주소를 직접 쳐도 관리자 화면으로 들어갈 수 없게 라우트 자체를 등록하지 않는다)
  if (isBranchSite()) {
    return (
      <div id="body-content">
        <Routes>
          <Route path="/branch/place_stat" element={<BranchPlaceStat />} />
          <Route path="/branch/accept_stat" element={<BranchAcceptStat />} />
          <Route path="*" element={<Navigate to="/branch/place_stat" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div id="body-content">
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/place/list" element={<PlaceList />} />
        <Route path="/testing_place_schedule/joins" element={<TestingPlaceScheduleJoins />} />
        <Route path="/testing_place_schedule/plan" element={<TestingPlaceSchedulePlan />} />
        <Route path="/testing_place/joins" element={<TestingPlaceJoins />} />
        <Route path="/testing_place/list" element={<TestingPlaceList />} />
        <Route path="/testing_teacher/setup" element={<TestingTeacherSetup />} />
        <Route path="/testing_teacher/joins" element={<TestingTeacherJoins />} />
        <Route path="/testing_accept/list" element={<TestingAcceptList />} />
        <Route path="/testing_accept/stat" element={<TestingAcceptStat />} />
        <Route path="/testing_print/list" element={<TestingPrintList />} />
        <Route path="/testing_hq_doc/list" element={<TestingHqDoc />} />
        <Route path="/testing_report/list" element={<TestingReportList />} />
      </Routes>
    </div>
  );
};


export default BodyContent;

